import { DynamicField } from "./dynamic-field.model";

export class DynamicColor<T> extends DynamicField<T> {

    inline?: boolean;
    format?: 'rgb' | 'hex' | 'hsb';

    constructor(source: Partial<DynamicColor<T>>) {
        super();
        this.format = 'hex';
        Object.assign(this, source);
    }
}